export const environment = {
  production: true,
  apiURL: "https://zenown-mono-api-stage.herokuapp.com"
};
